import { RawRuleOf } from '@casl/ability';

import { TagDto } from '../../../../tenant/tags/dtos/tag.dto';
import { AppAbility } from '../../authz/types/app-ability';
import { FileDto } from '../../files/dtos/file.dto';
import { UserRoleEnum } from '../enums/user-role.enum';
import { UserTypeEnum } from '../enums/user-type.enum';

import { UserWatchPreferenceDto } from './user-watch-preference.dto';

/**
 * Create user DTO
 */
export class CreateUserDto {
	color?: string;
	username!: string;
	authProviderName?: string;
	authProviderUserId?: string;
	notes?: string;
	type!: UserTypeEnum;
	email!: string;
	userRoleName!: UserRoleEnum;
	userRolePermissions!: RawRuleOf<AppAbility>[];
	tags?: TagDto[];
	files?: FileDto[];
	watchPreferences?: UserWatchPreferenceDto[];
}
